module.exports = __webpack_public_path__ + "static/s5-bg-20d620a7e2fc79ec18d73468bb410243.png";